module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/103W7bc/tc-custom/9781504024938.jpg?1706098014367",
      "alt": "This image is the cover for the book Midnight Round-Up, The Powder Valley Westerns"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Midnight Round-Up, The Powder Valley Westerns\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An all-star gang of villains descends on peaceful Powder Valley")]), _c('br'), _c('br'), _vm._v(" On a tawdry street in the heart of Denver, men crowd into the saloon for two reasons: cheap whiskey and Connie Dawson. The loveliest singer in Colorado, Connie has a golden voice and a brassy personality, but along with a crooked preacher, a hotshot gambler, and the fastest gunman in town, she’s about to find herself in a whole lot of trouble. All four owe the sinister Judge Prink a favor—and he’s ready to collect."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Prink has recently discovered the idyllic township of Powder Valley, home to Sheriff Pat Stevens and his faithful friends Sam and Ezra, and declared it ripe for the picking. With the help of his indentured gang of miscreants, he plans to strip the innocent little community bare. But when he meets Powder Valley’s courageous trio, Prink comes face to face with the law of the gun.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brett Halliday\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Brett Halliday (1904–1977) was the primary pseudonym of American author Davis Dresser. Halliday is best known for creating the Mike Shayne Mysteries. The novels, which follow the exploits of fictional PI Mike Shayne, have inspired several feature films, a radio series, and a television series. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0